import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-135ff323"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createElementVNode("i")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "手机快捷登录", -1))
const _hoisted_4 = { class: "phone" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "code-input" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-xinxi" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tip" }, "首次登录自动注册", -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode("登录")
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tip2" }, "若已开户，登录后可查看进度", -1))
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 阅读并同意")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("和")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_loading = _resolveComponent("van-loading")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_checkbox = _resolveComponent("van-checkbox")!
  const _component_van_form = _resolveComponent("van-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode(_component_van_form, {
      onSubmit: _ctx.login,
      onFailed: _ctx.checkInput,
      "validate-trigger": "onSubmit"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.show = true)),
            class: "area-code"
          }, [
            _createElementVNode("span", null, "+" + _toDisplayString(_ctx.areaCode), 1),
            _createVNode(_component_van_icon, { name: "arrow-down" })
          ]),
          _createVNode(_component_van_popup, {
            class: "code-option",
            show: _ctx.show,
            "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.show) = $event))
          }, {
            default: _withCtx(() => [
              (!_ctx.codeOptions)
                ? (_openBlock(), _createBlock(_component_van_loading, {
                    key: 0,
                    size: "24px",
                    color: "#959db7"
                  }))
                : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.codeOptions, (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: _normalizeClass(["item", item.areaCode === _ctx.areaCode ? 'selected' : '']),
                        key: item.areaCode,
                        onClick: _withModifiers(($event: any) => (_ctx.confirmCode(item.areaCode)), ["stop"])
                      }, [
                        _createElementVNode("span", null, _toDisplayString(item.cnName), 1),
                        _createElementVNode("span", null, "+" + _toDisplayString(item.areaCode), 1)
                      ], 10, _hoisted_6))
                    }), 128))
                  ]))
            ]),
            _: 1
          }, 8, ["show"]),
          _createVNode(_component_van_field, {
            name: "phone",
            border: false,
            modelValue: _ctx.phoneData.phone,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.phoneData.phone) = $event)),
            type: "number",
            maxlength: "11",
            placeholder: "请输入手机号码",
            rules: [
            {
              required: true,
              validator: _ctx.validatePhone
            }
          ]
          }, null, 8, ["modelValue", "rules"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_van_field, {
            border: false,
            modelValue: _ctx.phoneData.sms,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.phoneData.sms) = $event)),
            name: "sms",
            type: "number",
            maxlength: "6",
            center: "",
            clearable: "",
            placeholder: "请输入验证码",
            rules: [{ required: true }]
          }, {
            "left-icon": _withCtx(() => [
              _hoisted_8
            ]),
            button: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.smsData.codeDisabled ? 'disabled' : 'btn-code'),
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleSendSms && _ctx.handleSendSms(...args)))
              }, _toDisplayString(_ctx.smsData.codeDisabled ? `重新获取${_ctx.smsData.seconds}秒` : _ctx.smsData.btnTxt), 3)
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _hoisted_9,
        _createVNode(_component_van_button, {
          block: "",
          type: "primary",
          "native-type": "submit",
          class: "btn-login",
          loading: _ctx.btnLoading
        }, {
          default: _withCtx(() => [
            _hoisted_10
          ]),
          _: 1
        }, 8, ["loading"]),
        _hoisted_11,
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.hideAgree ? 'agree' : 'hide')
        }, [
          _createVNode(_component_van_checkbox, {
            modelValue: _ctx.phoneData.agree,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.phoneData.agree) = $event)),
            "checked-color": "#ffb400"
          }, {
            icon: _withCtx(() => [
              _createElementVNode("i", {
                class: "iconfont icon-gouxuan",
                style: _normalizeStyle({ color: _ctx.phoneData.agree ? '#ffb400' : '#A5B2DC' })
              }, null, 4)
            ]),
            default: _withCtx(() => [
              _hoisted_12,
              _createElementVNode("span", {
                onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toProtocol && _ctx.toProtocol(...args)), ["stop"]))
              }, "《个人资料收集声明》"),
              _createElementVNode("span", {
                onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toPrivacy && _ctx.toPrivacy(...args)), ["stop"]))
              }, "《网站使用条款》 "),
              _createElementVNode("span", {
                onClick: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toDisclaimer && _ctx.toDisclaimer(...args)), ["stop"]))
              }, "《免责声明》 "),
              _createElementVNode("span", {
                onClick: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toPrivacy1 && _ctx.toPrivacy1(...args)), ["stop"]))
              }, "《私隐政策》"),
              _hoisted_13,
              _createElementVNode("span", {
                onClick: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toElec && _ctx.toElec(...args)), ["stop"]))
              }, "《电子交易条款》")
            ]),
            _: 1
          }, 8, ["modelValue"])
        ], 2)
      ]),
      _: 1
    }, 8, ["onSubmit", "onFailed"])
  ]))
}